export enum FeatureFlagName {
  EAN_Compliancy = "EAN-Compliancy",

  // cx-product
  air_self_serve_core_exchange = "air-self-serve-core-exchange",
  copy_conversation_id = "AIAssistCopyConversationId",

  CheckoutPriceChangeThreshold = "checkout-price-change-threshold",
}
